<template>
  <tree :data="discountTypes"
        :indent="10"
        :space="0">
    <template v-if="!data.isDragPlaceHolder"
              slot-scope="{data, store}">
      <span class="text" @click="selectDiscountTypes(data)">{{ data.name }}</span>
      <span v-if="data.children && data.children.length"
            class="expand-btn"
            @click="store.toggleOpen(data)">
        <i class="mdi"
           :class="data.open ? 'mdi-menu-up' : 'mdi-menu-right'"></i>
      </span>
    </template>
  </tree>
</template>
<script>
  import { Tree } from 'vue-draggable-nested-tree';

  export default {
    name: 'DiscountTypeListTree',
    components: { Tree },
    props: {
      discountTypeList: {
        default: () => {
          return null;
        },
        type: Array
      }
    },

    data() {
      return {
        discountTypes: JSON.parse(JSON.stringify(this.discountTypeList))
      };
    },

    methods: {

      deselectAllDiscountTypes(arr) {
        arr.forEach(d => {
          d.active = false;
          if (d.children.length > 0) {
            this.deselectAllDiscountTypes(d.children);
          }
        });
      },

      selectDiscountTypes(discountType) {
        // this.selectedDiscountType = discountType;
        this.deselectAllDiscountTypes(this.discountTypes);
        discountType.active = true;
        // this.selectedDiscountType = discountType;
        // this.getDiscountList(discountType.sifr);
        // this.$bvModal.hide('test-modal');

        this.$emit('onSelectDiscountTypes', discountType);
      }

    }


  };
</script>

<style lang="stylus">
.tree-node {
    color: #616161
    font-weight: 600

    .tree-node-inner-back {
        background: #fff
    }

    &.active > .tree-node-inner-back {
        background: c-accent
        color: #fff

        .expand-btn {
            color: #fff
        }
    }

    &:hover > .tree-node-inner-back {
        background: #f0fcf0
        color: #616161
    }
}

.tree-node-inner {
    padding 10px
    cursor: pointer
    display flex
    justify-content space-between
    border-bottom: 1px solid #eee

    .text {
        flex auto
        font-size: 14px
    }

    .expand-btn {
        color: c-accent
        width: 30px
        text-align: center
        font-weight: bold
        font-size: 30px
        line-height: 24px
    }
}


.draggable-placeholder-inner {
    border: 1px dashed #0088F8
    box-sizing: border-box
    background: rgba(0, 136, 249, 0.09)
    color: #0088f9
    text-align: center
    padding: 0
    display: flex
    align-items: center
}

 .darkmode {
   .tree-node-inner {
     .expand-btn {
       color: c-accent-dark
     }
   }
   .tree-node {
     color: c-body-font-dark

     .tree-node-inner-back {
       background: c-dark-bg-light
       color: c-body-font-dark
     }

     &.active > .tree-node-inner-back {
       background: c-accent-dark
       color: #fff

       .expand-btn {
         color: #fff
       }
     }


     &:hover > .tree-node-inner-back {
       background: c-dark-bg
       color: #616161
     }

   }


   .tree-node-inner {
     border-bottom: 1px solid c-dark-bg-light
   }
 }
</style>
